import { GetServerSideProps } from "next";
import { parseCookies } from "nookies";
import { FilterPageComponent } from "pages-components/FilterPageComponent";

import CollectionsApi from "@/api/CollectionsApi";

export interface FilterPageProps {
  stores: string[];
  filter: {
    categories: string[];
    collections: string[];
    sizes: string[];
    colors: string[];
    discounts: number[];
    search: string;
  };
  header?: PageHeader;
}

const FilterPage = ({ stores, filter, header }: FilterPageProps) => {
  return (
    <FilterPageComponent stores={stores} filter={filter} header={header} />
  );
};

export const onlineStoreId = "2a50f1e1-f328-433f-80b8-77b79acec80d";

export const getServerSideProps: GetServerSideProps = async (context) => {
  const filterString = context.query?.filter as string;
  const filter = filterString && JSON.parse(filterString);
  const cityOnBoardingStores =
    parseCookies(context)["cityOnBoardingStores"] ||
    JSON.stringify([onlineStoreId]);
  const parsedStores = JSON.parse(cityOnBoardingStores);

  let pageHeader: PageHeader | null = null;

  if (filter?.collections?.length) {
    const collectionsResponse = await CollectionsApi.find(
      filter.collections[0]
    );
    const { header, header_poster, name } = collectionsResponse.data;
    if (header) {
      pageHeader = {
        banner: header,
        poster: header_poster,
        alt: name,
      };
    }
  }

  return {
    props: {
      stores: parsedStores,
      ...(filter && { filter }),
      header: pageHeader,
    },
  };
};

export interface PageHeader {
  banner: string;
  poster?: string;
  alt: string;
}

export default FilterPage;
